import React, { useState, useEffect } from "react";
import { FaRegCheckSquare } from "react-icons/fa";
import { MdCheckBoxOutlineBlank } from "react-icons/md";
import { GrResources } from "react-icons/gr";
import { MdDelete } from "react-icons/md";
import { Card as MuiCard, CardContent, Typography, Box } from "@mui/material";
import styled from "styled-components";
import API from "../../../utils/api";

const Card = styled(MuiCard)`
  background-color: #1b1a2ea9 !important;
  color: white;
  box-shadow: 0 0px 3px 3px #c77cda75;
  transition: all 0.5s ease 0s;
  margin-top: 0.7rem;
`;
const NameTypography = styled(Typography)`
  font-size: 1.2rem;
  text-align: left;
  width: 100%;
  padding-left: 1.2rem;
  color: white;
  @media (max-width: 600px) {
    padding-left: 0.5rem;
    font-size: 1rem;
  }
`;

const ResourceButton = styled(Typography)`
  font-size: 1.2rem;
  border-radius: 5px;
  color: #fff;
  margin-left: 1rem;
  @media (max-width: 600px) {
    font-size: 0.9rem; /* Adjust font size for mobile screens */
  }
`;

const colors = [
  "#87ceeb", // Sky Blue
  "#1fe46a", // Vibrant Green
  "#a986ad", // Muted Purple
  "#6b8e23", // Olive Green
  "#ffe0b2", // Soft Peach
  "#2e8b57", // Sea Green
  "#ff69b4", // Bright Pink
];
const ToggleButton = styled(Typography)`
  color: white;

  @media (max-width: 600px) {
    font-size: 0.9rem; /* Adjust font size for mobile screens */
  }
`;
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const TodoItem = ({ item, edit }) => {
  const [hidden, setHidden] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [dynamicColor, setDynamicColor] = useState(
    item.done ? "#1fe46a" : "#a986ad"
  );
  const handleCheckToggle = async () => {
    if (isProcessing) return; // Prevent multiple clicks during processing
    let updatedStatus = !isChecked;
    API.post("/api/learning/todoItemClick", {
      _id: item._id,
      updatedStatus: updatedStatus,
    }).catch((e) => {
      alert("Error: ", e);
    });
    setIsProcessing(true);
    for (let i = 0; i < 10; i++) {
      setDynamicColor(colors[i % colors.length]); // Cycle through colors
      await sleep(200); // Wait 0.25 seconds
    }

    // Final update after 2 seconds
    setIsChecked(updatedStatus); // Set final toggle state
    setDynamicColor(updatedStatus ? "#1fe46a" : "#a986ad"); // Final color based on state
    setIsProcessing(false); // Re-enable clicks
  };

  useEffect(() => {
    setIsChecked(item.done);
  }, [item]);

  const deleteItem = () => {
    API.post("/api/learning/deleteItem", {
      _id: item._id,
      type: "item",
      parentId: item.parentId,
    })
      .then((req) => req.data)
      .then((data) => {
        alert(data.message);
        setHidden(true);
      })
      .catch((e) => {
        alert("Error: ", e);
      });
  };

  return (
    <Card hidden={hidden}>
      <CardContent sx={{ padding: ".7rem !important" }}>
        <Box display="flex" justifyContent="space-between" alignItems="left">
          <ToggleButton onClick={handleCheckToggle} disabled>
            {isChecked ? (
              <>
                <FaRegCheckSquare color={dynamicColor} font-size="150%" />
              </>
            ) : (
              <>
                <MdCheckBoxOutlineBlank color={dynamicColor} font-size="150%" />
              </>
            )}
          </ToggleButton>
          <NameTypography>{item.name}</NameTypography>
          <Box display="flex" alignItems="left">
            {edit ? (
              <Typography>
                <MdDelete
                  color="#a986ad"
                  font-size="150%"
                  onClick={deleteItem}
                />
              </Typography>
            ) : (
              <>
                {item.link && (
                  <ResourceButton
                    onClick={() =>
                      window.open(item.link, "_blank", "noopener noreferrer")
                    }
                  >
                    <GrResources font-size="120%" />
                  </ResourceButton>
                )}
              </>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TodoItem;
